// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "i18n-extra" + "." + "1069615c549938aa" + ".js";
};